export function checkEmail (error) {
  return error.response &&
    error.response.data &&
    error.response.data.errors &&
    error.response.data.errors.email &&
    error.response.data.errors.email.length &&
    error.response.data.errors.email[0] === 'The email has already been taken.'
}
